import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    request: {
      acceptedTerms: false,
      declarantData: {
        names: "",
        firstLastName: "",
        secondLastName: "",
        email: "",
        state: "",
        municipality: ""
      },
      victimData: {
        names: "",
        firstLastName: "",
        secondLastName: "",
        eventDescription: "",
        state: "",
        municipality: "",
        locality: ""
      }
    },
    host: "http://mvdf.datacivica.org/",
    isLoading: false
  },
  mutations: {
    setIsLoadingState(state, isLoading) {
      state.isLoading = isLoading;
    },
    resetRequest(state) {
      state.request = {
        acceptedTerms: false,
        declarantData: {
          names: "",
          firstLastName: "",
          secondLastName: "",
          email: "",
          state: "",
          municipality: ""
        },
        victimData: {
          names: "",
          firstLastName: "",
          secondLastName: "",
          eventDescription: "",
          state: "",
          municipality: "",
          locality: ""
        }
      };
    }
  },
  actions: {
    createRequest({ state }) {
      return axios.post(state.host + "api/v1/request", {
        request: state.request
      });
    },
    verifyCaptcha({ state }, recaptchaToken) {
      return axios.post(state.host + "api/v1/verifyCaptcha", {
        recaptchaToken: recaptchaToken
      });
    }
  }
});
